import { constants, useTranslation } from 'cng-web-lib'

import MGTTAdminConfigKeys from 'src/constants/locale/key/MGTTAdminConfig'
import Namespace from 'src/constants/locale/Namespace'
import React from 'react'

const LogisticsAdminTranslationText = () => {
  const {
    locale: {
      key: { UiComponentKeys }
    }
  } = constants
  
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.CLOGS_CONFIG,
    Namespace.SEQUENCE,
    Namespace.JSON_SCHEMA,
    Namespace.CONTAINER_TYPE,
    Namespace.MODULE,
    Namespace.CUSTOM_USER_ACCOUNT
  ])

  let clogsConfig = translate(
    Namespace.CLOGS_CONFIG,
    MGTTAdminConfigKeys.TITLE
  )
  let clogsConfigTableTitle = translate(
    Namespace.UI_COMPONENT,
    UiComponentKeys.Table.TITLE,
    {
      nameTitleised: clogsConfig
    }
  )
  let configFor = translate(
    Namespace.CLOGS_CONFIG,
    MGTTAdminConfigKeys.CONFIG_FOR
  )
  let configValue1 = translate(
    Namespace.CLOGS_CONFIG,
    MGTTAdminConfigKeys.CONFIG_VALUE1
  )
  let configValue2 = translate(
    Namespace.CLOGS_CONFIG,
    MGTTAdminConfigKeys.CONFIG_VALUE2
  )
  let configValue3 = translate(
    Namespace.CLOGS_CONFIG,
    MGTTAdminConfigKeys.CONFIG_VALUE3
  )
  let configDescription = translate(
    Namespace.CLOGS_CONFIG,
    MGTTAdminConfigKeys.CONFIG_DESCRIPTION
  )

  return {
    clogsConfig,
    clogsConfigTableTitle,
    configFor,
    configValue1,
    configValue2,
    configValue3,
    configDescription
  }
}

export default LogisticsAdminTranslationText
